module.exports = __webpack_public_path__ + "src/assets/img/activities_bar.b4e3721f.jpg";